import Vue from 'vue';

import App from './App.vue';
import { store } from './store';

new Vue({
	el: '#daumWrap',
	render: h => h(App),
	store,
});
